import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import _ from "lodash";
import makeRequest from "../../../api";
import { nutritionApiService } from "../../../api/services";
import { toast } from "react-toastify";

const AnalysisComponent = () => {
  const params = useParams();
  const userId = params.userId;
  const [mealPlanAnalyisData, setMealPlanAnalyisData] = useState<any>({
    weeklyRecipeData: {},
  });

  const getCompleteMealplan = async () => {
    try {
      const response = await makeRequest(
        nutritionApiService.getCompleteMealPlanForUser(userId)
      );
      if (!response?.data?.status) {
        setMealPlanAnalyisData(response?.data?.data);
      }
    } catch (error: any) {
      toast.error(error?.message);
    }
  };

  useEffect(() => {
    if (userId) {
      getCompleteMealplan();
    }
  }, []);

  return (
    <div>
      <div className="container mt-5">
        <nav aria-label="breadcrumb" style={{ marginBottom: "16px" }}>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="/">Home</a>
            </li>
            <li className="breadcrumb-item">
              <a href={"/users/" + userId + "/meal-plan"}>Mealplan</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Mealplan Analysis
            </li>
          </ol>
        </nav>
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item">
            <a
              className="nav-link active"
              id="home-tab"
              data-toggle="tab"
              href="#home"
              role="tab"
              aria-controls="home"
              aria-selected="true"
            >
              Weekly Recipes
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              id="profile-tab"
              data-toggle="tab"
              href="#profile"
              role="tab"
              aria-controls="profile"
            >
              Other
            </a>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <h3>Week wise recipe data</h3>
            <div>
              {Object.keys(mealPlanAnalyisData?.weeklyRecipeData)?.map(
                (weekNo: any, index: number) => {
                  let weekRecipeKeys = Object.keys(
                    mealPlanAnalyisData?.weeklyRecipeData?.[weekNo]
                  );
                  return (
                    <table style={{ marginTop: "16px" }} key={"table" + weekNo}>
                      <tbody>
                        <tr>
                          <td>
                            <b>{weekNo}</b>
                          </td>
                        </tr>
                        {weekRecipeKeys?.map((key) => {
                          let value =
                            mealPlanAnalyisData?.weeklyRecipeData?.[weekNo]?.[
                              key
                            ];

                          return (
                            <tr>
                              <td>{`${key} : ${value}`}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  );
                }
              )}
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <h3>Profile Content</h3>
            <p>This is the content of the Profile tab.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalysisComponent;
